import { Controller } from "@hotwired/stimulus";

// 選択されたらsubmitする
export class CheckSubmitController extends Controller {
  static targets = ["submitUnset", "submitSet"];

  change(e) {
    const submitTargetName = e.currentTarget.dataset.checkSubmitSubmitParam;
    const submitTarget = this.targets.find(submitTargetName);
    if (e.currentTarget.checked && submitTarget && !submitTarget.disabled) submitTarget.click();
  }
}
